import React, { useState } from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import UserInfo from 'components/UserInfo'

import EmptyUserInfo from '../EmptyUserInfo'

import classes from './SnippetsList.module.scss'

/** @type {import("./types").default} */
const SnippetsList = ({ list, className, ...props }) => {
  const [page, setPage] = useState(0)

  const isLastPage = page === list.length - 1
  const currentItem = list[page]
  const showControls = list.length > 1
  const hasUser = !!currentItem?.user_info && currentItem?.user_info?.full_name

  const handleNext = () => {
    setPage(page + 1)
  }

  const handlePrevious = () => {
    setPage(page - 1)
  }

  return (
    !!list.length && (
      <Grid className={clsx('SnippetsList', classes.root, className)} {...props}>
        <div>
          {list.map((item, index) => {
            return (
              <Typography
                key={`snippet-${index}`}
                variant="body-sm"
                className={clsx(classes.summary, { [classes.visible]: index === page })}
              >
                &ldquo;
                {item.summary}
                &rdquo;
              </Typography>
            )
          })}
        </div>
        <div className={classes.controlsContainer}>
          {hasUser ? (
            <UserInfo
              fullName={currentItem.user_info.full_name}
              userInfo={currentItem.user_info}
              jobTitle={currentItem.user_info.job_title}
              pictureUrl={currentItem.user_info.picture_url}
              isVerifiedReviewer={currentItem.user_info.is_verified}
              className={classes.userInfo}
            />
          ) : (
            <EmptyUserInfo />
          )}
          {showControls && (
            <div className={classes.controls}>
              <IconButton onClick={handlePrevious} disabled={page === 0}>
                <Icon icon="chevron-left" size={12} />
              </IconButton>
              <span>
                {page + 1}/{list.length}
              </span>
              <IconButton onClick={handleNext} disabled={isLastPage}>
                <Icon icon="chevron-right" size={12} />
              </IconButton>
            </div>
          )}
        </div>
      </Grid>
    )
  )
}

export default SnippetsList
